"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarginSymbol = exports.CashSymbol = exports.MarginBoard = exports.CashBoard = exports.Positions = void 0;
class Positions {
    constructor(obj) {
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.Positions = Positions;
class CashBoard {
}
exports.CashBoard = CashBoard;
class MarginBoard {
}
exports.MarginBoard = MarginBoard;
class CashSymbol {
}
exports.CashSymbol = CashSymbol;
class MarginSymbol {
}
exports.MarginSymbol = MarginSymbol;
//# sourceMappingURL=Positions.js.map